/**
 * Gold hairline that anchors a numbered section header.
 *
 * Colour comes from the `gold` token rather than a literal, so a reskin for
 * the next shop changes one hex in tailwind.config instead of hunting every
 * rule on the page.
 */

export function BrassRule({ width = 48, className = '' }: { width?: number; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block h-px bg-gold ${className}`}
      style={{ width: `${width}px` }}
    />
  );
}

export default BrassRule;
